import gql from 'graphql-tag';

export const BlogTree = gql`
	query BlogTree(
		$spaceKey: String!
		$first: Int
		$endCursor: String
		$statuses: [String]
		$orderBy: String
		$metadataSort: Boolean
	) {
		content(
			spaceKey: $spaceKey
			type: "blogpost"
			first: $first
			orderby: $orderBy
			after: $endCursor
			status: $statuses
		) {
			pageInfo {
				hasNextPage
				endCursor
			}
			nodes {
				id
				title
				status
				blank
				properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
					nodes {
						id
						key
						value
					}
				}
				links {
					webui
				}
				history @skip(if: $metadataSort) {
					createdDate
				}
				metadata {
					lastModifiedDate
					createdDate @include(if: $metadataSort)
				}
			}
		}
	}
`;
